import { render, staticRenderFns } from "./withdraw-result.vue?vue&type=template&id=250dd822&scoped=true&"
import script from "./withdraw-result.vue?vue&type=script&lang=js&"
export * from "./withdraw-result.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-result.vue?vue&type=style&index=0&id=250dd822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250dd822",
  null
  
)

export default component.exports